<template>
  <div v-if="user == 0 && (owner === 'drr')">
    <b-card style="background-color: rgb(255, 127, 96, 0.0); border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
      <div>
        <b-img
          class="mr-1 mb-1"
          height="25"
          src="@/assets/images/iconsDB/icontime.svg"
        />
        <span style="font-size:20px; color: #fff; font-weight: 600;">Top 5 สายทางที่มีปริมาณจราจรต่อชั่วโมงมากที่สุด</span>
      </div>
      <div>
        <b-row
          v-for="(itemT, indexT) in progressT.slice(0, 5)"
          :key="indexT"
          style="margin-top: 38px;"
        >
          <b-col lg="9">
            <b-link to="/">
              <label style="color: #ffffff; font-size: 18px; width: 110%;">{{ indexT+1 +'. ' }} {{ itemT.WayID }}</label>
            </b-link>
            <b-progress
              :value="itemT.Total_PCU"
              :max="progressT[0].Total_PCU + 50"
              precision="2"
              :class="colorprogressT[indexT]"
            />
          </b-col>
          <b-col
            lg="3"
            style="text-align: center;"
          >
            <span style="color:#ffffff; font-size: 17px;">{{ itemT.Total_PCU.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} PCU/ชม.</span>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BRow, BCol, BProgress, BImg, BLink, BCard,
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  name: 'Top5TrafficRoutes',
  components: {
    BRow,
    BCol,
    BProgress,
    BImg,
    BLink,
    BCard,
  },
  data() {
    return {
      progressT: [],
      colorprogressT: [
        'progress1', 'progress2', 'progress3', 'progress4', 'progress5',
      ],
      userData: JSON.parse(localStorage.getItem('userData')),
      user: '',
      owner: '',
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.interval = setInterval(() => {
      this.getPieCountingDB()
    }, 300000)
  },
  mounted() {
    this.user = this.userData.department
    this.owner = this.userData.groupname
    this.getPieCountingDB()
  },
  methods: {
    getPieCountingDB() {
      axios
        .post('/getTop5VKTDB', {
          department: this.userData.department,
          owner: this.userData.groupname,
          username: this.userData.username,
        })
        .then(response => {
          this.progressT = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>
